import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Paginator as FoundationsPaginator } from 'foundations-components/transitional/components/Paginator';
import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import unescapedText from 'I18n/utils/unescapedText';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';

// The maximum number of records crmsearch can page through
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RESULTSET_LIMIT = 10000;
const Paginator = t0 => {
  const $ = _c(16);
  const {
    pageIndex,
    pageSize,
    pageSizes,
    paginatorAlignment,
    totalRowCount,
    onPageIndexChange,
    onPageSizeChange
  } = t0;
  const pageCount = Math.ceil(totalRowCount / pageSize);
  let t1;
  if ($[0] !== onPageIndexChange) {
    t1 = t2 => {
      const {
        target: t3
      } = t2;
      const {
        value
      } = t3;
      return onPageIndexChange({
        nextPageIndex: value - 1
      });
    };
    $[0] = onPageIndexChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePageChange = t1;
  const t2 = paginatorAlignment === "start" ? "start" : "center";
  const t3 = pageIndex + 1;
  const t4 = RESULTSET_LIMIT / pageSize;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.pagination.tooManyRecords"
    });
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== handlePageChange || $[4] !== pageCount || $[5] !== t3 || $[6] !== t4) {
    t6 = /*#__PURE__*/_jsx(FoundationsPaginator, {
      "data-test-id": "table-paginator",
      page: t3,
      pageCount: pageCount,
      onPageChange: handlePageChange,
      enabledPageLimit: t4,
      disabledPageTooltipTitle: t5
    });
    $[3] = handlePageChange;
    $[4] = pageCount;
    $[5] = t3;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onPageSizeChange || $[9] !== pageSize || $[10] !== pageSizes) {
    t7 = pageSizes.length >= 1 && /*#__PURE__*/_jsx(Dropdown, {
      "data-test-id": "table-page-size-selector",
      "data-test-value": pageSize,
      buttonUse: "transparent",
      buttonText: unescapedText("datatable.pagination.pageCountButton", {
        count: pageSize
      }),
      children: /*#__PURE__*/_jsx(List, {
        children: pageSizes.map(size => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": `page-size-${size}`,
            use: "link",
            onClick: () => onPageSizeChange({
              nextPageSize: size
            }),
            children: unescapedText("datatable.pagination.pageCountButton", {
              count: size
            })
          })
        }, size))
      })
    });
    $[8] = onPageSizeChange;
    $[9] = pageSize;
    $[10] = pageSizes;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t6 || $[14] !== t7) {
    t8 = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: t2,
      marginBlockStart: "100",
      marginBlockEnd: "100",
      children: [t6, t7]
    });
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default Paginator;